var map = {
	"./disney_01.png": 7666,
	"./disney_02.png": 6557,
	"./disney_03.png": 1173,
	"./disney_04.png": 6562,
	"./disney_05.png": 8461,
	"./foodmate_01.jpg": 900,
	"./foodmate_02.jpg": 817,
	"./foodmate_03.jpg": 7252,
	"./foodmate_04.jpg": 9107,
	"./ipad_01.png": 6806,
	"./ipad_02.png": 4170,
	"./ipad_03.png": 4089,
	"./ipad_04.png": 5152,
	"./kt_01.png": 2484,
	"./kt_02.png": 9261,
	"./kt_03.png": 4306,
	"./kt_04.png": 7808,
	"./kt_05.png": 4665,
	"./movie_01.png": 7728,
	"./movie_02.png": 2356,
	"./movie_03.png": 411,
	"./movie_04.png": 4290,
	"./pokemon_01.png": 613,
	"./pokemon_02.png": 3088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1937;